import { Component } from '@angular/core';
import { DevelopChallengeComponent } from '../develop-challenge.component';
import { CnAiService } from '../../challenges_service/cn-ai.service';

@Component({
  selector: 'app-develop-challenge-issues',
  templateUrl: './develop-challenge-issues.component.html',
  styleUrls: ['./develop-challenge-issues.component.scss']
})
export class DevelopChallengeIssuesComponent {

  constructor(public developChallengeComponent: DevelopChallengeComponent, private aiService: CnAiService) {}

  openAiSidebar() {
    const context = this.developChallengeComponent?.selected_issue || [];
    this.aiService.openSidebar(
      'develop', 'issues', context,
      'Generate 5 potential issues or concerns {persona} with the solution. Current context: {context}',
      'issue_content', this.developChallengeComponent
    );
  }
}
